<template>
  <div class="dialog-content">

    <el-dialog title="运动员选择" :visible.sync="isShow" @close="onClose">
      <el-input placeholder="请输关键字搜索" v-model="keywords" @input="onSearch"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      <div style="margin: 10px 0">可选列表</div>
      <div class="picker-cell-group" v-if="options.length>0">
        <div class="picker-cell" v-for="(item, index) in options" :v-if="index < limit">
          <el-checkbox :value="item.checked"  @change="toggle(item)">{{item.name}}({{(item.sex==1? '男':'女')+' '+item.num}})</el-checkbox>
        </div>
      </div>
      <div v-else>
        没有记录...
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="memberAdd">新增运动员</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
    .use(Toast)
    .use(Cell)
    .use(CellGroup)
    .use(Icon)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup);

export default {
  name: "YundongyuanAbilityPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      isShow: false,
      result: [],
      list:[],
      keywords: "",
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.id) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.id
      })
    }
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    memberAdd(){
      rbLink({
        name: 'AbilityApplyMemberAdd'
      })
    },
    onClose() {
      this.$emit("onClose");
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
          "/api/ability/MemberOptions",
          { keywords: this.keywords },
          res => {
            that.list = [...res.data];
          }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    }
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// YundongyuanAbilityPicker.vue?2e960a9a